<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Select Bencher Quantity">
                    <FormRow> 
                      <NcsyIsraelBencherAmounts/>                    
                      <ErrorLabel field="amount" />
                    </FormRow>
                    <FormRow>
                      <Receipt :receipts="['us','israel']"/>                 
                    </FormRow>
                    <br/>
                    <FormRow>
                      <FormLabel>
                        <input type="checkbox" field="custom.anonymous" :checked="anonymous" @click="anonymous = $event.target.checked"/> Make my donation anonymous
                      </FormLabel>
                    </FormRow>
                    <FormRow>
                      <InHonorOfBencher /> 
                    </FormRow>                    
                </FormSection>                
                <FormSection title="Personal Information">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                           
                </FormSection>
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
                <PaymentButton showAmount />
            </PaymentForm>
        </div>
    </div>
</div>
</template>
<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({

  setup() {
    const { setValue, form } = usePaymentForm();

    const anonymous = ref();

    watch(anonymous, () => {
      if (anonymous.value) {
        setValue("custom.anonymous", anonymous.value);
      }
    });

    return {
      form,
      anonymous,
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
::v-deep .radio-inline {
  margin-left: 20px !important;
}
</style>

